import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import {
  Button,
  Collapse,
  Input,
  Form,
  message,
  Popconfirm,
  Upload,
} from "antd";
import { ClipLoader } from "react-spinners";
import { UserContext } from "../../../App";
import {
  handleLogout,
  handleUpdateUser,
} from "../../../Utils/UpdateUsersState";
import { DeleteOutlined, EditOutlined, KeyOutlined } from "@ant-design/icons";

import {
  deleteUser,
  passwordReset,
  editUser,
  uploadProfilePicture,
} from "../../../API/User/user";
import { UserOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const Settings = () => {
  const [user, setUser] = useState({});
  const {
    userData,
    userPages,
    setUserToken,
    setUserData,
    setUserPages,
    setUserApiKeyStatus,
  } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [mode, setMode] = useState(null); // "edit" or "reset"

  const [form] = Form.useForm();

  useEffect(() => {
    if (userData) {
      setUser({
        ...userData,
        pages: userPages,
      });
    }
  }, [loading]);

  const handleDeleteUser = async (user_role) => {
    setLoadingDelete(true);

    try {
      const response = await deleteUser(user_role);
      if (response.status === 204) {
        handleLogout(
          setUserData,
          setUserToken,
          setUserPages,
          setUserApiKeyStatus
        );
        message.success("User Deleted Successfully");
      } else {
        message.error("Unable To Delee User At Moment");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      setLoadingDelete(false);
    }
  };
  const handleEditClick = () => {
    setMode("edit");
    form.setFieldsValue({
      name: user?.first_name,
      email: user?.last_name,
    });
  };

  const handleResetClick = () => {
    if (mode) {
      setMode(null);
    }
    setMode("reset");
    form.resetFields();
  };

  const handleSave = async () => {
    const values = await form.validateFields();
    let response;
    if (mode === "edit") {
      response = await editUser(user?.id, values.first_name, values.last_name);
    } else if (mode === "reset") {
      response = await passwordReset(user?.id, values.newPassword);
    }
    if (response?.status === 200) {
      message.success(response?.data?.message);
      if (mode === "edit") {
        const updatedUser = {
          ...user,
          name: response?.data.name,
        };
        setUser(updatedUser);
        handleUpdateUser(setUserData, updatedUser);
      }
    } else {
      const error = mode === "edit" ? "Update User" : "Reset Password";
      message.error(
        response?.data?.error || `Unable To ${error} At The Moment`
      );
    }
    setMode(null);
    form.resetFields();
  };

  const handlePictureUpload = async ({ file }) => {
    if (file.status !== "uploading") {
      const response = await uploadProfilePicture(file);
      if (response?.status === 200) {
        const updatedUser = {
          ...user,
          profile_picture:
            process.env.REACT_APP_MEDIA_URL + response?.data.profile_picture,
        };
        setUser(updatedUser);
        handleUpdateUser(setUserData, updatedUser);
        message.success("Profile Updated Successfully");
      } else {
        message.error("Error In Updating Profile");
      }
    }
  };

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className="loader-container"
      >
        <ClipLoader size={50} color={"#123abc"} loading={loading} />
      </div>
    );
  }

  return (
    <div className="user-company">
      <Collapse
        bordered={false}
        activeKey={mode ? ["1"] : []}
        onChange={(keys) => {
          if (keys.length === 0) {
            setMode(null);
          }
        }}
        expandIcon={() => null}
      >
        <Panel
          key="1"
          header={
            <div className="user-info">
              {/* Profile Info with Ant Design Upload */}
              <div className="user-details">
                <div className="compact-avatar">
                  {user?.profile_picture ? (
                    <img
                      className="profile-pic"
                      src={user?.profile_picture}
                      alt="user-icon"
                    />
                  ) : (
                    <UserOutlined className="profile-pic" />
                  )}
                </div>
                <div className="profile-details">
                  <div className="profile-name">{user?.name}</div>
                  <div className="profile-email">{user?.email}</div>
                  <Upload
                    showUploadList={false}
                    onChange={handlePictureUpload}
                    accept=".jpeg,.jpg,.png"
                    beforeUpload={() => false}
                  >
                    <div className="upload-btn">Upload Photo</div>
                  </Upload>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="action-buttons">
                <div className="reset-btn" onClick={handleResetClick}>
                  <KeyOutlined />
                  <span>Reset Password</span>
                </div>
                <div className="edit-btn" onClick={handleEditClick}>
                  <EditOutlined />
                  <span>Edit Profile</span>
                </div>
              </div>
            </div>
          }
        >
          {/* Panel Content */}
          <div className="form-container">
            {mode && (
              <Form className="settings-form" form={form} layout="vertical">
                <div className="form-row">
                  {mode === "edit" && (
                    <>
                      <div className="form-fields">
                        <Form.Item
                          label="First Name"
                          name="first_name"
                          className="form-input"
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          label="Last Name"
                          name="last_name"
                          className="form-input"
                        >
                          <Input />
                        </Form.Item>
                      </div>
                      <div className="form-button">
                        <Button onClick={handleSave}>Save Profile</Button>
                      </div>
                    </>
                  )}

                  {mode === "reset" && (
                    <>
                      <div className="form-fields">
                        <Form.Item
                          label="New Password"
                          name="newPassword"
                          className="form-input"
                          rules={[
                            {
                              required: true,
                              message: "Please enter a new password",
                            },
                            {
                              min: 6,
                              message:
                                "Password must be at least 6 characters!",
                            },
                          ]}
                        >
                          <Input.Password />
                        </Form.Item>
                        <Form.Item
                          label="Retype Password"
                          name="confirmPassword"
                          className="form-input"
                          dependencies={["newPassword"]}
                          rules={[
                            {
                              required: true,
                              message: "Please confirm the password",
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("newPassword") === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error("Passwords do not match!")
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password />
                        </Form.Item>
                      </div>
                      <div className="form-button">
                        <Button onClick={handleSave}>Save Password</Button>
                      </div>
                    </>
                  )}
                </div>
              </Form>
            )}
          </div>
        </Panel>
      </Collapse>

      <div className="delete-panel">
        <div className="section-company section-delete">
          <div className="section-text-company">
            <div className="section-title-company">
              <div> Delete User</div>
            </div>

            <div className="section-description-user" style={{ color: "red" }}>
              This action will remove the user. Continue?
            </div>
          </div>
          <Popconfirm
            title="Delete the user"
            description="Are you sure to delete this user?"
            onConfirm={() => handleDeleteUser(user?.role)}
            okText="Yes"
            cancelText="No"
            placement="left"
          >
            <Button
              icon={<DeleteOutlined />}
              loading={loadingDelete}
              style={{ backgroundColor: "transparent" }}
              className="delete-btn"
              danger
            >
              Delete
            </Button>
          </Popconfirm>
        </div>
      </div>
    </div>
  );
};

export default Settings;
